// Posts a form submission to the /api/notify serverless function, which emails
// Lily via Resend. Throws with a usable message on failure so callers can show
// an error and fall back to "email lily@lilylaisf.com directly".
//
// A network failure or server error is retried once after a short pause, so a
// momentary blip doesn't cost a lead. A 4xx means the submission itself was
// rejected, and resending it would fail the same way. A retry can occasionally
// produce a duplicate notification; Cloze dedupes by email, and a duplicate is
// far cheaper than a lost lead.
const RETRY_DELAY_MS = 1500;

async function post(payload) {
  const res = await fetch('/api/notify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    // Lets the request finish even if the visitor navigates away or closes the
    // tab right after submitting (the valuation lead is sent in the background).
    keepalive: true,
  });

  if (!res.ok) {
    let message = 'Request failed';
    try {
      const data = await res.json();
      if (data && data.error) message = data.error;
    } catch (_) {
      /* non-JSON error body */
    }
    const err = new Error(message);
    err.retryable = res.status >= 500;
    throw err;
  }

  return res.json();
}

export async function sendNotification(payload) {
  try {
    return await post(payload);
  } catch (err) {
    // fetch() rejects with a TypeError on network failure; HTTP errors are tagged above.
    const retryable = err.retryable || err instanceof TypeError;
    if (!retryable) throw err;
    await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
    return post(payload);
  }
}
